import React, { useEffect } from "react";
import lottie from 'lottie-web';
import animationData from "../../../../../landing-pages/js/common/animation/animation-data/Onboard_text_json/data.json";

const OnboardingAnimation = () => {
  useEffect(() => {
    lottie.loadAnimation({
      container: document.getElementById('onboarding-animation'),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet'
      }
    });
  }, []);
  
  return(
    <div id="onboarding-animation"></div>
  )
}

export default OnboardingAnimation;